import React, { useState } from "react";
import siteManagementService from "../../../services/SiteManagementService";
import LocationForm from "../Forms/LocationForm";
import LoginPicklistItemForm from "../Forms/LoginPicklistItemForm";
import FormModal, { ModalMessageSettings, getResultMessage } from "../../Common/FormModal";
import { LPLItemDTO, LocationDTO } from "@beable/roster-backend-client-v1";

interface EditModalProps {
  open: boolean;
  handleClose: any;
  editingLocation: boolean;
  locationItem: LocationDTO | undefined;
  parentLocations: LocationDTO[];
  locations: LocationDTO[];
  siteItem: LPLItemDTO | undefined;
}

export default function EditModal({
  editingLocation,
  ...props
}: EditModalProps) {
  const [messageSetting, setMessageSetting] = useState<ModalMessageSettings>();
  const [isLoading, setIsLoading] = useState(false);

  const submitLocationForm = async (
    name: string,
    isoCode: string,
    parentId: number,
    id?: number,
    hasChildren?: boolean
  ) => {
    const locationPayload: LocationDTO = {
      id: id!,
      parentId: parentId,
      name: name.trim(),
      isoCode: isoCode.trim(),
      hasChildren: hasChildren!,
    };
    setIsLoading(true);
    const result = await siteManagementService.updateLocation(locationPayload);
    const message = getResultMessage(
      result,
      `Location edited successfully!`,
      `Failed to edit this location!`
    );
    setMessageSetting(message);
    setIsLoading(false);
  };

  const submitLPLItemForm = async (
    name: string,
    purl: string,
    stateName: string,
    id?: string
  ) => {
    const sitePayload: LPLItemDTO = {
      id: id!,
      name: name.trim(),
      leaid: '',
      siteName: purl.trim(),
      state: stateName.trim(),
    };
    setIsLoading(true);
    const result = await siteManagementService.updateLPLItem(sitePayload);
    const message = getResultMessage(
      result,
      `Site edited successfully!`,
      `Failed to edit this site!`
    );
    setMessageSetting(message);
    setIsLoading(false);
  };

  const getName = () =>
    editingLocation ? props.locationItem!.name : props.siteItem!.name;

  const getTitle = () => `Edit ${getName()}`;

  const getDescription = () => {
    const descriptor = editingLocation ? "location" : "site";
    return `Edits the ${getName()} ${descriptor}.`;
  };

  const handleClose = () => {
    props.handleClose(messageSetting?.severity === "success");
    setMessageSetting(undefined);
  }

  return (
    <FormModal
      isOpen={props.open}
      title={getTitle()}
      description={getDescription()}
      isLoading={isLoading}
      handleClose={handleClose}
      message={messageSetting}
    >
      {editingLocation ? (
        <LocationForm
          parentLocations={props.parentLocations}
          submitForm={submitLocationForm}
          onClose={handleClose}
          selectedItem={props.locationItem}
        />
      ) : (
        <LoginPicklistItemForm
          locations={props.locations}
          submitForm={submitLPLItemForm}
          onClose={handleClose}
          selectedItem={props.siteItem}
        />
      )}
    </FormModal>
  );
}
